import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";

import { cn } from "../lib/utils";

/**
 * v2 Label (redesign phase 5, #455). One style for every form label: Sora
 * Semibold 14/20, `--ink`, sentence case (break #43). The grey UPPERCASE
 * eyebrow is InfoRow's key style, not a form label.
 *
 * Optional fields are marked "(optional)"; required fields carry no mark
 * (break #44): most lytra fields are required, so the exception is marked.
 * The mark is part of the label text, so it is also in the accessible name.
 */

export interface LabelProps extends React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> {
  optional?: boolean;
  /** Shown in parentheses after the label. German UI text. */
  optionalText?: string;
  /** Dims the label like its disabled control. */
  disabled?: boolean;
}

const Label = React.forwardRef<React.ElementRef<typeof LabelPrimitive.Root>, LabelProps>(function Label(
  { optional = false, optionalText = "optional", disabled = false, className, children, ...props },
  ref,
) {
  return (
    <LabelPrimitive.Root
      ref={ref}
      data-disabled={disabled || undefined}
      className={cn(
        "font-sans text-label text-ink data-disabled:cursor-not-allowed data-disabled:opacity-50",
        className,
      )}
      {...props}
    >
      {children}
      {/* The space sits outside the span: accessible-name computation trims each element's own text. */}
      {optional && (
        <>
          {" "}
          <span className="font-normal text-ink-muted">{`(${optionalText})`}</span>
        </>
      )}
    </LabelPrimitive.Root>
  );
});

export { Label };
